import * as types from 'constants/actionTypes';
import LOOKUP from 'constants/lookup';
import initialState from './initialState';
import moment from 'moment';
import { mapOfflineOrder, mapOfflineProducts } from '../utils/mappers';
export default function entityReducer(state = initialState.entity, action) {
  switch (action.type) {
    /* ACCOUNT */
    case types.GET_USER_ROLES_SUCCESS: {
      return {
        ...state,
        rolesList: action.roles,
      };
    }

    case types.DELETE_ROLE_SUCCESS: {
      return {
        ...state,
        saveSuccess: true,
        saveError: null,
      };
    }
    case types.DELETE_ROLE_FAILED: {
      return {
        ...state,
        saveSuccess: false,
        saveError: action.error,
      };
    }

    case types.GET_POLICIES_SUCCESS: {
      return {
        ...state,
        policies: action.data,
      };
    }

    case types.GET_POLICIES_FAILED: {
      return {
        ...state,
      };
    }

    case types.UPDATE_HIDDEN_ROLES_SUCCESS: {
      return {
        ...state,
        rolesList: state.rolesList.map((item) =>
          action.data.includes(item.id)
            ? { ...item, isVisible: false }
            : { ...item, isVisible: true }
        ),
      };
    }

    case types.USERROLE_GET_REPORTBYNAME_SUCCESS: {
      return {
        ...state,
        userRoleReport: action.userRoleReport,
      };
    }
    case types.USERROLE_GET_PAGEBYNAME_SUCCESS: {
      return {
        ...state,
        userRolePage: action.userRolePage,
      };
    }

    case types.USERROLE_REPORT_SAVED: {
      return {
        ...state,
        userRoleReport: action.userRoleReport,
      };
    }

    case types.USERROLE_PAGE_SAVED: {
      const userRoles = action.userRolePage;
      const authUser = state.common && state.common.authenticatedUser;
      const authUserRole = authUser && authUser.roles ? authUser.roles : null;

      if (authUserRole && authUserRole === userRoles.name) {
        return {
          ...state,
          userRolePage: action.userRolePage,
        };
      } else {
        return {
          ...state,
        };
      }
    }

    case types.USERROLE_GET_REPORT_FAILED: {
      return {
        ...state,
      };
    }

    case types.USERROLE_GET_PAGE_FAILED: {
      return {
        ...state,
      };
    }

    /* PRODUCT CATEGORY */
    case types.GET_PRODUCT_CATEGORIES_SUCCESS: {
      return {
        ...state,
        categoriesList: action.data.list,
        categoriesListLength: action.data.total,
      };
    }

    case types.GET_PRODUCT_CATEGORIES_BYBRANCHS_SUCCESS: {
      return {
        ...state,
        categoriesList: action.data.list,
        categoriesListLength: action.data.total,
      };
    }

    case types.GET_CATEGORY_TREE_SUCCESS: {
      return {
        ...state,
        categoryTree: action.data,
      };
    }

    case types.GET_CLASSES_OF_CANNABIS_SUCCESS: {
      return {
        ...state,
        classesOfCannabis: action.data,
      };
    }

    case types.CATEGORY_UPDATE_MEMBER_PRICE_SUCCESS: {
      return {
        ...state,
        categoryMemberPriceUpdateCount: action.data,
      };
    }

    case types.CATEGORY_UPDATE_MEMBER_PRICE_SUCCESS_RESET: {
      return {
        ...state,
        categoryMemberPriceUpdateCount: 0,
      };
    }

    /* PRODUCT */
    case types.INITIALIZE_POPAGE_PRODUCT_LIST:
      return {
        ...state,
        productList: [],
        productListLength: null,
      };

    case types.GOT_PRODUCT_DETAIL:
    case types.GET_PRODUCT_BY_BARCODE_SUCCESS:
      return {
        ...state,
        productDetail: action.data[0],
        scannedProducts: action.data,
        scannedTime: new Date().getTime(),
      };

    case types.GET_PRODUCT_BY_BARCODE_FAIL:
      return {
        ...state,
        barcodeNotFound: new Date().getTime(),
      };

    case types.CLEAN_PRODUCT_DETAIL:
      return {
        ...state,
        productDetail: null,
      };

    case types.CLEAN_ORDER_DETAIL:
      return {
        ...state,
        posOrder: null,
        sellableProductsAll: [],
        sellableProductsWeightList: [],
      };

    case types.PRODUCT_TYPES_GOT:
      return {
        ...state,
        productTypesList: action.types,
      };

    case types.BRANDS_GOT:
      return {
        ...state,
        productBrands: action.brands,
      };

    case types.GET_PRODUCT_LOCATIONS_SUCCESS:
      return {
        ...state,
        productLocations: action.data,
      };
    case types.PRODUCTS_BY_CATEGORY_GOT:
      return {
        ...state,
        productByCategory: action.products,
      };
    case types.PRODUCTS_CATEGORIES_GOT:
      return {
        ...state,

        productCategories: action.categories,
      };
    case types.PRODUCTS_CATEGORIES_DROPDOWN_GOT:
      return {
        ...state,
        productCategories: action.categories,
      };
    case types.PRODUCTS_GOT:
      return {
        ...state,
        productList: [...action.products.list],
        productListLength: action.products.total,
      };

    case types.PRODUCTS_GOT_CAMPAIGN:
      return {
        ...state,
        productList: [...action.products.list],
        productListLength: action.products.total,
        productListAll: action.products.all,
      };

    case types.PRODUCTS_GOT_CAROUSEL:
      return {
        ...state,
        productList: [...action.products.list],
        productListLength: action.products.total,
        productListAll: action.products.all,
      };

    case types.PRODUCTS_CLEAR_CAROUSEL:
      return {
        ...state,
        productList: [],
        productListLength: 0,
        productListAll: [],
      };

    case types.PRODUCT_BY_ID_SUCCESS:
      return {
        ...state,
        productDetail: {
          ...action.product,
          priceMatrix: action.matrix,
        },
      };
    case types.INITIALIZE_STORE_PRODUCT:
      return {
        ...state,
        [action.compName + 'Types']: [
          {
            text: 'Bulk',
            value: 'Bulk',
            unitOfMeasurement: 'Weight',
            categories: [
              { text: 'Sativa', value: 1 },
              { text: 'Indica', value: 2 },
              { text: 'Hybrid', value: 3 },
              { text: 'Hash', value: 4 },
              { text: 'Concentrate', value: 5 },
            ],
          },
          {
            text: 'Unit',
            value: 'Unit',
            unitOfMeasurement: 'Unit',
            categories: [
              { text: 'Edibles', value: 6 },
              { text: 'Pills', value: 7 },
              { text: 'Tinctures', value: 8 },
              { text: 'Accessories', value: 9 },
              { text: 'Vaporizer', value: 10 },
            ],
          },
        ],
        [action.compName + 'SaveSuccess']: null,
      };

    case types.REST_PRODUCT_CATEGORIES:
      return {
        ...state,
        productCategories: [],
      };

    case types.GOT_PRODUCT_ORDERS:
      return {
        ...state,
        productOrderList: { list: action.data.list, total: action.data.total },
        productOrderTotal: action.data.total,
      };

    case types.GOT_CAMPAIGN_LIST:
      return {
        ...state,
        productCampaignList: action.data.list,
        productCampaignTotal: action.data.total,
      };

    case types.GOT_PURCHASE_ORDER_LIST:
      return {
        ...state,
        productPurchaseOrderList: action.data.list,
        productPurchaseOrderTotal: action.data.total,
      };

    case types.RESET_PRODUCT_LIST:
      return {
        ...state,
        productOrderList: { list: [], total: 0 },
        productOrderTotal: 0,
        productCampaignList: [],
        productCampaignTotal: 0,
        productPurchaseOrderList: [],
        productPurchaseOrderTotal: 0,
      };

    // VENDOR
    case types.VENDORS_GOT:
      return {
        ...state,
        vendorList: [...action.vendors.list],
        vendorsListLength: action.vendors.total,
      };
    case types.CATEGORY_CREATED:
      return { ...state, categoryList: [...action.data] };
    case types.CATEGORY_CREATE_FAILED:
      return state;
    // PATIENT
    case types.PATIENT_LIST_LOADED:
      return {
        ...state,
        patientList: [...action.patients.list],
        patientListLength: action.patients.total,
      };

    case types.GOT_PATIENT_DETAIL:
      return {
        ...state,
        patientDetail: action.data,
        sbPatientExists: action.sbPatientExists,
      };

    case types.RESET_PATIENT_LISTS:
      return {
        ...state,
        patientDetail: {},
        patientOrders: [],
        patientRewardPoints: [],
      };
    case types.GET_BULK_MEMBER_PRICE_HISTORY_SUCCESS:
      return {
        ...state,
        bulkUpdateMemberPriceHistoryList: [...action.data.list],
        bulkUpdateMemberPriceHistoryListLength: action.data.total,
      };

    case types.GET_BULK_MEMBER_PRICE_CATEGORY_HISTORY_SUCCESS:
      return {
        ...state,
        bulkUpdateMemberPriceCategoryHistoryList: [...action.data.list],
        bulkUpdateMemberPriceCategoryHistoryListLength: action.data.total,
      };

    case types.GET_PRODUCT_CATEGORY_BULK_UPDATE_PRICE_HISTORY_SUCCESS:
      return {
        ...state,
        productCategoryBulkUpdatePriceHistoryList: [...action.data.list],
        productCategoryBulkUpdatePriceHistoryListLength: action.data.total,
      };

    case types.SAVE_PRODUCT_CATEGORY_TAX_PROVINCE_SUCCESS:
      return {
        ...state,
        saveProductCategoryTaxProvinceSuccessTime: new Date().getTime(),
      };

    case types.SAVE_PRODUCT_CATEGORY_TAX_PROVINCE_FAIL:
      return {
        ...state,
        saveProductCategoryTaxProvinceSuccessTime: null,
        saveProductCategoryTaxProvinceError: action.error,
        saveProductCategoryTaxProvinceErrorTime: new Date().getTime(),
      };

    case types.EDIT_ELITE_MEMBERSHIP: {
      return {
        ...state,
        saveSuccess: false,
        saveError: null,
      };
    }

    case types.EDIT_ELITE_MEMBERSHIP_SUCCESS: {
      return {
        ...state,
        patientDetail: {
          ...state.patientDetail,
          eliteMemberStartDate: action.data.eliteMemberStartDate,
          eliteMemberEndDate: action.data.eliteMemberEndDate,
        },
        saveSuccess: true,
        saveError: null,
      };
    }

    case types.EDIT_ELITE_MEMBERSHIP_FAILED: {
      return {
        ...state,
        patientDetail: {
          ...state.patientDetail,
        },
        saveSuccess: false,
        saveError: action.message,
      };
    }

    /* DOCTOR */
    case types.DOCTOR_LIST_LOADED:
      return {
        ...state,
        doctorList: [...action.doctors.list],
        doctorListLength: action.doctors.total,
      };

    /* PURCHASE ORDER */
    case types.INITIALIZE_STORE_PURCHASEORDER:
    case types.PURCHASE_ORDER_CREATED:
    case types.PURCHASE_ORDER_EDITED:
      return { ...state, productListPO: [] };
    case types.ADD_PRODUCT_PO:
      return {
        ...state,
        productListPO: [...state.productListPO, { ...action.product }],
      };
    case types.REMOVE_PO_PRODUCT: {
      let finalProductListPO = [...state.productListPO];
      finalProductListPO.splice(action.index, 1);
      return { ...state, productListPO: finalProductListPO };
    }
    case types.UPDATE_PURCHASE_ORDER: {
      return {
        ...state,
        productListPO: state.productListPO.map((item) => {
          return item.id == action.id
            ? {
                ...item,
                unitPrice: Number(action.price),
                price: action.subtotal,
                notes: action.notes,
              }
            : item;
        }),
      };
    }
    case types.UPDATE_PO_UNRECEIVE: {
      return {
        ...state,
        productListPO: state.productListPO.map((item) => {
          return item.id == action.id
            ? {
                ...item,
                status: 'Opened',
                packageReference: '',
                canUnreceive: false,
                actualQuantity: 0,
              }
            : item;
        }),
      };
    }
    case types.PO_LIST_LOADED:
      return {
        ...state,
        purchaseOrderList: [...action.purchaseOrders.list],
        purchaseOrderListLength: action.purchaseOrders.total,
      };
    case types.PURCHASE_FORM_LOADED:
      return {
        ...state,
        productListPO: [...action.purchaseOrder.products],
        purchaseOrder: action.purchaseOrder,
      };
    case types.PURCHASE_PRODUCT_LOADED: {
      return { ...state, receivedPOProduct: action.product };
    }
    /* EMPLOYEE */
    case types.EMPLOYEE_LIST_LOADED:
      return {
        ...state,
        employeeList: [...action.employees.list],
        employeeListLength: action.employees.total,
      };

    case types.ALL_EMPLOYEES_GOT:
    case types.GET_ACTIVE_EMPLOYEE_BY_BRANCH_SUCCESS: {
      return {
        ...state,
        employeeList: action.employees,
      };
    }

    case types.GET_EMPLOYEE_BY_FILTER_SUCCESS: {
      return {
        ...state,
        employeeSendList: action.employees,
      };
    }

    case types.AUTHENTICATED_EMPLOYEE_GOT: {
      return {
        ...state,
        authenticatedEmployee: action.employee,
      };
    }

    case types.EMPLOYEE_GOT_DETAILS: {
      return {
        ...state,
        employeeDetails: action.employee,
      };
    }
    case types.RESET_EMPLOYEE_LISTS: {
      return {
        ...state,
        shiftsListFilter: [],
        shiftsListFilterLength: 0,
        patientOrders: [],
      };
    }

    /* INVENTORY TRANSFER */
    case types.WAREHOUSES_GET_SUCCESS: {
      return {
        ...state,
        warehouses: action.data,
      };
    }

    case types.GET_INVENTORY_ADJUST_SUCCESS: {
      return {
        ...state,
        inventoryAdjust: action.data.list,
        inventoryAdjustLength: action.data.total,
      };
    }

    case types.WAREHOUSES_CLEAR: {
      return {
        ...state,
        warehouses: [],
      };
    }
    case types.WAREHOUSES_GET_ERROR: {
      return {
        ...state,
        warehouses: [],
      };
    }

    case types.ADJUST_PRODUCT_WAREHOUSE_SUCCESS: {
      return {
        ...state,
        productForAdjustment: null,
      };
    }

    case types.AUDIT_PRODUCT_UPDATE_EXPECTED_QTY_SUCCESS:
    case types.ADJUST_PRODUCT_QTY_SUCCESS: {
      return {
        ...state,
        adjustProductSuccessTimeStamp: new Date().toLocaleString(),
      };
    }

    case types.AUDIT_PRODUCT_QTY_WITH_LOCK_SUCCESS:
      return {
        ...state,
        inventoryAudit: {
          ...state.inventoryAudit,
          products: state.inventoryAudit.products.map((item) =>
            item.id == action.data.productId &&
            item.warehouseType == action.data.WarehouseType
              ? { ...item, expectedQty: action.data.expectedQty }
              : item
          ),
        },
      };

    case types.CONVERT_BULK_TO_UNIT_SUCCESS: {
      return {
        ...state,
        productForAdjustment: null,
      };
    }
    case types.SET_SELECTED_PRODUCT_ADJUSTMENT: {
      return {
        ...state,
        productForAdjustment: { ...action.product },
      };
    }
    case types.SEND_TRANSFER_PRODUCT: {
      return {
        ...state,
        productForAdjustment: { ...action.product },
      };
    }
    case types.SEND_BULKTOUNIT_PRODUCT: {
      return {
        ...state,
        productForAdjustment: { ...action.product },
      };
    }
    case types.CLEAR_SELECTED_PRODUCT_ADJUSTMENT: {
      return {
        ...state,
        productForAdjustment: null,
      };
    }

    case types.VERIFY_CREDENTIAL_SUCCESS: {
      return {
        ...state,
        isCredentialAuthorized: action.data,
      };
    }

    case types.VERIFY_CREDENTIAL_CLEAR: {
      return {
        ...state,
        isCredentialAuthorized: null,
      };
    }

    case types.PRODUCTS_IN_TRANSIT_LOADED: {
      return { ...state, productsInTrasitList: [...action.productsInTransit] };
    }
    case types.PRODUCT_WAREHOUSE_REFRESH: {
      return {
        ...state,
        refreshWarehouses: new Date().toLocaleString(),
        refreshInventoryAdjust: new Date().toLocaleString(),
        isCredentialAuthorized: null,
      };
    }

    case types.PRODUCTWAREHOUSE_LIST_LOADED: {
      if (action.isTransfer) {
        return {
          ...state,
          productsTransfer: action.productsWarehouse,
        };
      }
      return {
        ...state,
        productsWarehouses: action.productsWarehouse,
      };
    }

    case types.BULK_TRANSFER_SUCCESS: {
      return {
        ...state,
        bulkTransferSuccess: new Date().getTime(),
      };
    }

    case types.PRODUCTWAREHOUSE_GROUPED_LIST_LOADED: {
      if (action.productId) {
        if (
          action.productsWarehouse &&
          action.productsWarehouse.list &&
          action.productsWarehouse.list.length > 0
        ) {
          return {
            ...state,
            productForAdjustment: action.productsWarehouse.list[0],
          };
        } else {
          return {
            ...state,
          };
        }
      } else if (action.isTransfer) {
        return {
          ...state,
          productsTransfer: action.productsWarehouse,
        };
      }
      return {
        ...state,
        productsWarehouses: action.productsWarehouse,
      };
    }

    case types.PRODUCTWAREHOUSE_AUTOCOMPLETE_LIST_LOADED: {
      return {
        ...state,
        productsWarehouses: action.productsWarehouse,
      };
    }

    case types.BULK_TRANSFER_EXCEL_SEARCH_LIST_LOADED: {
      return {
        ...state,
        bulkTransferExcelProducts: action.bulkTransferExcelProducts,
      };
    }

    case types.BULK_TRANSFER_CONFIRM_SUCCESS: {
      return {
        ...state,
        bulkTransferSuccess: new Date().getTime(),
        bulkTransferNoQuantity: action.bulkTransferNoQuantity,
      };
    }

    case types.BULK_TRANSFER_LIST_LOADED: {
      return {
        ...state,
        bulkTransferList: action.data,
        bulkTransferListLength: action.data.total,
      };
    }

    case types.BULK_TRANSFER_LOADED: {
      return {
        ...state,
        bulkTransfer: action.data.data,
      };
    }

    case types.BULK_TRANSFER_SCAN_PRODUCT_SUCCESS: {
      return {
        ...state,
        bulkTransferScanProductData: action.bulkTransferScanProductData,
        bulkTransferScannedTime: new Date().getTime(),
      };
    }

    case types.GET_PENDING_BULK_TRANSFER_PRODUCTS_SUCCESS: {
      return {
        ...state,
        pendingBulkTransferProducts: action.data,
      };
    }

    case types.PRODUCT_QUANTITY_LOADED: {
      return {
        ...state,
        productQuantity: action.data,
      };
    }

    case types.TRANSFER_PRODUCTS_TO_WAREHOUSE_SUCCESS: {
      return {
        ...state,
        warehouseErrors: action.errors,
        productsTransfer: [],
      };
    }

    case types.TRANSFER_PRODUCT_WAREHOUSE_FAILED: {
      return {
        ...state,
        warehouseErrors: action.errors,
      };
    }

    case types.CLEAN_WAREHOUSE_ERRORS: {
      return {
        ...state,
        warehouseErrors: [],
      };
    }

    // AUDIT
    case types.GET_AUDIT_SUCCESS:
    case types.AUDIT_UPDATE_SUCCESS: {
      return {
        ...state,
        inventoryAudit: action.data,
        inventoryAuditUpdateScanned: action.scanned,
      };
    }

    case types.GET_AUDITS_SUCCESS: {
      return {
        ...state,
        inventoryAudits: action.data,
      };
    }

    case types.AUDIT_WAREHOUSES_SUCCESS: {
      return {
        ...state,
        auditWarehouses: action.data,
      };
    }

    case types.GET_PRODUCT_BARCODE_INVENTORY_AUDIT_SUCCESS: {
      return {
        ...state,
        inventoryAuditScan: action.data,
      };
    }

    case types.PRODUCTS_AUDIT_GOT: {
      return {
        ...state,
        auditProductList: action.data.list,
        auditProductListLength: action.data.total,
      };
    }

    case types.CATEGORY_AUDIT_GOT: {
      return {
        ...state,
        auditCategoryList: action.data.list,
        auditCategoryListTimeStamp: new Date().getTime(),
      };
    }

    case types.UNCOUNTED_AUDIT_GOT: {
      return { ...state, auditUncountedList: action.data.categories };
    }

    case types.CATEGORIES_AUDIT_GOT: {
      return { ...state, auditCategoriesList: action.data.categories };
    }

    case types.BRANDS_GOT_LIST: {
      return { ...state, brandList: action.data };
    }

    case types.BRAND_AUDIT_GOT: {
      return {
        ...state,
        auditBrandList: action.data,
        auditBrandListTimeStamp: new Date().getTime(),
      };
    }

    // WEIGHT
    case types.WEIGHT_SETTING_GOT_ALL: {
      return {
        ...state,
        weightSettingsList: [...action.weightSettings],
      };
    }

    // PRICE MATRIX
    case types.PRICE_MATRIX_GOT_ALL: {
      return {
        ...state,
        priceMatricesList: [...action.priceMatrices],
      };
    }

    case types.PRICE_MATRIX_GOT: {
      return {
        ...state,
        priceMatrix: action.priceMatrix,
      };
    }

    // POS
    case types.POS_GOT: {
      return {
        ...state,
        productCategories: action.data.productCategories,
        paymentsList: action.data.paymentsMethods,
        sellableProducts: action.data.productsList,
        sellableProductsAll: action.data.productsList,
        sellableProductsLength: action.data.productsLength,
        cashFlow: action.data.cashFlow,
        pinPadId: action.data.pinPadId,
        pinPadIntegrated: action.data.pinPadIntegrated,
        weightList: action.data.weightList,
        brandList: action.data.brands,
        internalMessage:
          action.data.internalMessage && action.data.internalMessage.message,
        bannerImageURL:
          action.data.internalMessage &&
          action.data.internalMessage.bannerImageURL,
        ipAddress: action.data.ipAddress,
      };
    }
    case types.GET_POS_PATIENTS: {
      return {
        ...state,
        posPatients: [],
        posPatientsLength: 0,
      };
    }
    case types.INITIALIZE_STORE_POS: {
      return {
        ...state,
        posPatients: [],
        posPatientsLength: 0,
        posOrder: null,
      };
    }
    case types.INITIALIZE_STORE_POS_PATIENT: {
      return {
        ...state,
        posPatients: [],
        posPatientsLength: 0,
      };
    }
    case types.SELLABLE_PRODUCTS_GOT: {
      const { data, model } = action || {};
      let newSellableProductsAll = [];

      if (
        !state.sellableProductsAll ||
        state.sellableProductsAll.length === 0 ||
        model.page === 1
      ) {
        newSellableProductsAll = [...data.list];
      } else {
        newSellableProductsAll = [...state.sellableProductsAll, ...data.list];
      }

      return {
        ...state,
        sellableProducts: [...data.list],
        sellableProductsAll: newSellableProductsAll,
        sellableProductsLength: data.total,
        sellableProductsWeightList: data.productWeightList,
      };
    }

    case types.SET_CACHED_PRODUCTS: {
      return {
        ...state,
        sellableProducts: action.products,
        sellableProductsAll:
          state.sellableProductsAll && state.sellableProductsAll.length > 0
            ? [...state.sellableProductsAll.concat(action.products)]
            : action.products,
      };
    }

    case types.SEARCH_CACHED_PRODUCTS: {
      return {
        ...state,
        sellableProducts: action.products,
        sellableProductsAll: action.products,
      };
    }

    case types.SET_PRODUCT_LIST_EMPTY:
      return {
        ...state,
        sellableProducts: [],
        sellableProductsAll: [],
        sellableProductsLength: 0,
      };

    case types.SELABLE_BY_ID_GOT: {
      return {
        ...state,
        POSproductFiltered: action.data,
      };
    }

    case types.CLEAR_POS_FILTER: {
      return {
        ...state,
        POSproductFiltered: null,
        productFilter: null,
      };
    }
    case types.POS_PATIENTS_GOT: {
      return {
        ...state,
        posPatients: [...action.data.list],
        posPatientsLength: action.data.total,
      };
    }
    case types.FINALIZE_POS_ORDER_SUCCESS:
    case types.SET_ORDER_PRODUCT_DISCOUNT_SUCCESS:
    case types.SET_ORDER_DISCOUNT_SUCCESS:
    case types.CLEAR_TAX_POS_ORDER_SUCCESS:
    case types.ADD_SHIPPING_COST_SUCCESS:
    case types.POS_ORDER_SAVED: {
      return {
        ...state,
        posOrder: { ...action.data },
        cashFlow: action.currentCashFlow
          ? action.currentCashFlow
          : state.cashFlow,
      };
    }
    case types.SEND_ORDER_TO_FULFILLMENT_SUCCESS: {
      return {
        ...state,
        posOrder: { ...action.data },
        sendToFulfillmentSuccess: new Date().getTime(),
      };
    }
    case types.MANAGER_APPROVAL_SUCCESS: {
      return {
        ...state,
        managerApprovalSuccess: true,
        managerApprovalTimeStamp: new Date().getTime(),
        managerApprovalUserId: action.data.userId,
      };
    }
    case types.MANAGER_APPROVAL_FAILED: {
      return {
        ...state,
        managerApprovalSuccess: false,
        managerApprovalTimeStamp: new Date().getTime(),
      };
    }
    case types.POS_ORDER_SAVED_PRINT_RECEIPT: {
      return {
        ...state,
        posOrder: { ...action.data },
        cashFlow: action.currentCashFlow
          ? action.currentCashFlow
          : state.cashFlow,
        posCreated: new Date().getTime(),
      };
    }

    case types.CLEAR_OFFLINE_ORDER_ERROR: {
      return {
        ...state,
        posOrder: {
          ...state.posOrder,
          totalQtyExceed: false,
          totalGramExceed: false,
        },
      };
    }

    case types.SAVE_POS_ORDER_OFFLINE: {
      const order = { ...action.order };
      const newProducts = [...action.newProducts];

      const posOrder = mapOfflineOrder(order);
      const oldProducts = order && order.products ? order.products : [];
      const productsToAdd = mapOfflineProducts(oldProducts, newProducts, order);

      if (!productsToAdd) {
        return {
          ...state,
          posOrder: state.posOrder
            ? { ...state.posOrder, totalQtyExceed: true }
            : null,
        };
      }

      // SubTotal doesn't incldue member price - Only for inspired
      const subTotal = productsToAdd.reduce(
        (sum, product) =>
          product.status != 4
            ? sum + (product.originalNonMemberPrice || 0)
            : sum,
        0
      );
      const totalDiscount = productsToAdd.reduce(
        (sum, product) =>
          product.status != 4 ? sum + (product.discountAmount || 0) : sum,
        0
      );
      const totalGram = productsToAdd.reduce(
        (sum, product) =>
          product.status != 4
            ? sum + (product.weightPerUnit * product.quantity || 0)
            : sum,
        0
      );

      if (totalGram > 30) {
        return {
          ...state,
          posOrder: {
            ...state.posOrder,
            totalGramExceed: true,
          },
        };
      }

      return {
        ...state,
        posOrder: {
          ...posOrder,
          products: productsToAdd,
          subTotal: subTotal,
          subTotalIncludingDiscounts: subTotal - totalDiscount,
          total: 0, // subTotalIncluingDiscount + tax
          balanceDue: 0,
          tipAmount: 0,
          change: 0.0,
          paid: 0.0,
          totalProducts: productsToAdd.length,
          totalGram: totalGram,
          totalGramExceed: false,
          totalQtyExceed: false,
        },
      };
    }

    case types.UPDATE_PACKAGE_REFERENCE: {
      let productsCopy = [];
      state.posOrder.products.map((product) => {
        if (product.orderProductId === action.orderProductId) {
          productsCopy.push({
            ...product,
            packageReference: action.packageReference,
            quantityInStock: product.packages.find(
              (pk) => pk.packageReference == action.packageReference
            ).quantity,
          });
        } else {
          productsCopy.push(product);
        }
      });

      return {
        ...state,
        posOrder: {
          ...state.posOrder,
          products: productsCopy,
        },
      };
    }

    case types.VOID_POS_ORDER_OFFLINE_PRODUCT: {
      let productsCopy = [];
      state.posOrder.products.map((product) => {
        if (product.orderProductId === action.product.orderProductId) {
          productsCopy.push({
            ...product,
            status: 4,
          });
        } else {
          productsCopy.push(product);
        }
      });

      const subTotal = productsCopy.reduce(
        (sum, product) =>
          product.status != 4
            ? sum + (product.originalNonMemberPrice || 0)
            : sum,
        0
      );
      const totalDiscount = productsCopy.reduce(
        (sum, product) =>
          product.status != 4 ? sum + (product.discountAmount || 0) : sum,
        0
      );
      const totalGram = productsCopy.reduce(
        (sum, product) =>
          product.status != 4
            ? sum + (product.weightPerUnit * product.quantity || 0)
            : sum,
        0
      );

      return {
        ...state,
        posOrder: {
          ...state.posOrder,
          products: productsCopy,
          subTotal: subTotal,
          subTotalIncludingDiscounts: subTotal - totalDiscount,
          total: 0,
          balanceDue: 0,
          tipAmount: 0,
          change: 0.0,
          paid: 0.0,
          totalProducts: productsCopy.length,
          totalGram: totalGram,
          totalGramExceed: false,
        },
      };
    }

    case types.GET_CASHFLOW_ORDERS_DETAIL_SUCCESS: {
      return {
        ...state,
        cashFlowOrdersDetail: action.data,
        printAllReceiptTime: new Date().getTime(),
      };
    }

    case types.REMOVE_ORDER_PRODUCT_DISCOUNT_SUCCESS: {
      return {
        ...state,
        posOrder: { ...action.data },
        cashFlow: action.currentCashFlow
          ? action.currentCashFlow
          : state.cashFlow,
      };
    }

    case types.REMOVE_ORDER_DISCOUNT_SUCCESS: {
      return {
        ...state,
        posOrder: { ...action.data },
        cashFlow: action.currentCashFlow
          ? action.currentCashFlow
          : state.cashFlow,
      };
    }
    case types.SAVE_POS_ORDER_ERROR: {
      return {
        ...state,
        posOrderError: { ...action.data },
        cashFlow:
          action.data && action.data.cashFlow
            ? action.data.cashFlow
            : state.cashFlow,
      };
    }
    case types.POS_ORDER_CANCELLED: {
      return {
        ...state,
        posOrder: { ...action.data },
      };
    }
    case types.CLEAR_POS_ERROR: {
      return {
        ...state,
        posOrderError: null,
      };
    }
    case types.GET_SELLABLE_PRODUCT_BY_ID_ERROR:
    case types.SEND_ORDER_EMAIL_RECEIPT_ERROR:
    case types.SEND_ORDER_SMS_RECEIPT_ERROR:
    case types.GET_POS_ORDER_ERROR:
    case types.ADD_PAYMENT_POS_ORDER_ERROR:
    case types.CANCEL_POS_ORDER_ERROR:
    case types.VOID_POS_ORDER_PRODUCT_ERROR:
    case types.ADD_SHIPPING_COST_FAIL:
    case types.ADD_TIP_AMOUNT_FAIL:
    case types.CHECK_ORDER_UPDATE_TIME_FAIL:
    case types.FINALIZE_POS_ORDER_ERROR: {
      return {
        ...state,
        posOrderError: { ...action.error },
      };
    }

    case types.CHECK_ORDER_UPDATE_TIME_OK: {
      return {
        ...state,
        posOrderCheckUpateTimePassed: new Date().getTime(),
      };
    }

    case types.CHECK_ORDER_UPDATE_TIME_REFUND_OK: {
      return {
        ...state,
        posOrderCheckUpateTimeRefundPassed: new Date().getTime(),
      };
    }

    case types.GET_ORDER_PATIENT_REWARD_SUCCESS:
      return {
        ...state,
        posOrder: {
          ...state.posOrder,
          patientRewardPoints: action.data,
        },
      };

    case types.CHECK_PRICE_ESTIMATION_SUCCESS: {
      return {
        ...state,
        productPriceEstimation: { ...action.data },
      };
    }

    case types.INITIALIZE_POS_ADD_PRODUCT:
    case types.CHECK_PRICE_ESTIMATION_ERROR: {
      return {
        ...state,
        productPriceEstimation: null,
      };
    }

    case types.SET_PRODUCT_FILTER:
      return {
        ...state,
        productFilter: {
          ...state.productFilter,
          productId: action.productId,
        },
      };

    case types.GET_PRODUCT_SUGGESTION_SUCCESS:
      return {
        ...state,
        posProductSuggestions: action.data,
      };

    // DEVICE
    case types.DEVICE_GOT_ALL: {
      return {
        ...state,
        devicesList: [...action.devices],
      };
    }

    case types.DEVICE_SAVED: {
      // if (window.store) {
      //   const applicationSettings = window.store.getState().common.applicationSettings;
      //   localStorage.setItem(applicationSettings.deviceKeyName, JSON.stringify({ ...action.data }));
      // }

      return {
        ...state,
        [action.compName + 'SavedDevice']: { ...action.data },
      };
    }

    case types.DEVICE_IP_UPDATED: {
      // if (window.store) {
      //   const applicationSettings = window.store.getState().common.applicationSettings;
      //   localStorage.setItem(applicationSettings.deviceKeyName, JSON.stringify({ ...action.data }));
      // }

      return {
        ...state,
        SavedDevice: { ...action.data },
      };
    }

    case types.GET_DEVICE_BY_IP_SUCCESS: {
      // const applicationSettings = window.store.getState().common.applicationSettings;
      // localStorage.setItem(applicationSettings.deviceKeyName, JSON.stringify({ ...action.data }));
      return {
        ...state,
        SavedDevice: { ...action.data },
      };
    }

    case types.GET_DEVICE_BY_IP_FAIL: {
      return {
        ...state,
      };
    }

    // DEVICE TYPE
    case types.DEVICETYPE_GOT_ALL: {
      return {
        ...state,
        deviceTypesList: [...action.deviceTypes],
      };
    }

    // DEVICE ROLE
    case types.DEVICEROLE_GOT_ALL: {
      return {
        ...state,
        deviceRolesList: [...action.deviceRoles],
      };
    }

    case types.DEVICEROLE_SAVED: {
      let deviceRolesList = [...state.deviceRolesList];
      deviceRolesList.push({ ...action.data });

      return {
        ...state,
        deviceRolesList: deviceRolesList,
      };
    }

    // DEVICE WORKSTATION
    case types.DEVICEWORKSTATION_GOT_ALL: {
      return {
        ...state,
        deviceWorkStationsList: [...action.deviceWorkStations],
      };
    }

    case types.DEVICEWORKSTATION_SAVED: {
      let deviceWorkStationsList = [...state.deviceWorkStationsList];
      deviceWorkStationsList.push({ ...action.data });

      return {
        ...state,
        deviceWorkStationsList: deviceWorkStationsList,
      };
    }

    // BANK DEPOSITS
    case types.BANKDEPOSITS_GOT: {
      return { ...state, bankDeposit: { ...action.response } };
    }

    case types.BANKDEPOSITS_GOT_ALL: {
      return { ...state, bankDeposits: { ...action.response } };
    }

    // SAFE MANAGEMENT
    case types.SAFEMANAGEMENT_GOT_ALL: {
      return {
        ...state,
        safeManagement: action.response,
      };
    }

    // CASH FLOW
    case types.CASHFLOW_GOT_ALL: {
      return {
        ...state,
        cashFlowsList: [...action.cashFlows.list],
        cashFlowsListTotal: action.cashFlows.total,
      };
    }

    case types.CASHFLOW_GOT: {
      return {
        ...state,
        cashFlow: action.cashFlow,
      };
    }

    case types.CLEAR_CASHFLOW: {
      return {
        ...state,
        cashFlow: null,
      };
    }

    case types.CASHFLOW_CLOSEDREGISTER:
    case types.CASHFLOW_SAVED_CASHOUTMANUAL:
    case types.CASHFLOW_SAVED_CASHIN: {
      return {
        ...state,
        cashFlow: action.cashFlow,
        cashInSavedTime: new Date().getTime(),
      };
    }

    case types.CASHFLOW_SAVED_CASHDROP: {
      return {
        ...state,
        cashFlow: action.cashFlow,
        cashDropSavedTime: new Date().getTime(),
      };
    }

    case types.CASHFLOW_ORDERS_GOT: {
      return {
        ...state,
        cashFlowOrders: action.cashFlowOrders,
      };
    }

    case types.CASHFLOW_REGISTERS_CLOSED: {
      return {
        ...state,
        cashFlow: action.cashFlow,
      };
    }

    case types.CASHFLOW_REGISTERS_CLOSED_FROM_CASHIN: {
      return {
        ...state,
        cashFlow: action.cashFlow,
      };
    }

    case types.CASHFLOW_SAVED_CASHIN_ERROR: {
      return {
        ...state,
        cashFlowError: action.error,
      };
    }

    case types.CLEAN_CASHFLOW_SAVED_CASHIN_ERROR: {
      return {
        ...state,
        cashFlowError: {},
      };
    }

    case types.CASHFLOW_REGISTER_COUNT_GOT: {
      return {
        ...state,
        cashFlowRegisterCount: action.data,
      };
    }

    case types.CASHFLOW_REGISTER_COUNT_CLEAR: {
      return {
        ...state,
        cashFlowRegisterCount: {},
      };
    }

    // PAYMENT
    case types.PAYMENT_GOT_ALL: {
      return {
        ...state,
        paymentsList: [...action.payments],
      };
    }

    // TAXRATE
    case types.TAXRATE_GOT_ALL: {
      return {
        ...state,
        taxesrateList: [...action.taxesrate],
      };
    }

    // ORDER
    case types.OPEN_ORDERS_GOT: {
      return {
        ...state,
        openOrdersList: [...action.data.list],
        openOrdersListLength: action.data.total,
      };
    }
    case types.RECENT_ORDERS_GOT: {
      return {
        ...state,
        recentOrdersList: action.data,
      };
    }

    case types.OLD_OPEN_ORDERS_GOT: {
      return {
        ...state,
        oldOpenOrders: action.oldOpenOrderIds,
        oldOpenOnlineOrders: action.openUnpaidOnlineOrderIds,
        oldOpenOrderGotTime: new Date().getTime(),
      };
    }

    case types.GET_INVENTORY_FLAG_SUCCESS: {
      return {
        ...state,
        inventoryFlags: action.data,
        inventroyFlagGotTime: new Date().getTime(),
      };
    }

    case types.ID_ORDER_HISTORY_DIALOG: {
      return {
        ...state,
        idOrderHistoryDialog: action.id,
      };
    }

    // BRANCH
    case types.BRANCHES_GOT: {
      return {
        ...state,
        branches: action.data,
      };
    }

    //CAMPAIGN
    case types.CAMPAIGN_GOT_ALL: {
      return {
        ...state,
        campaignList: action.data.list,
        campaignListLength: action.data.total,
      };
    }

    case types.CLEAR_CAMPAIGN_ITEMS_DIALOG: {
      return {
        ...state,
        productList: [],
        productListLength: 0,
        productListAll: [],
      };
    }

    case types.CAMPAIGN_GOT: {
      return {
        ...state,
        compaign: action.data,
      };
    }

    case types.CLEAR_CAMPAIGN_FORM: {
      return {
        ...state,
        compaign: null,
      };
    }

    //COMBO
    case types.COMBO_GET_ALL_SUCCESS: {
      return {
        ...state,
        comboList: action.data,
      };
    }

    case types.COMBO_GET_SUCCESS: {
      return {
        ...state,
        combo: action.data,
      };
    }

    case types.CLEAR_COMBO_FORM: {
      return {
        ...state,
        combo: null,
      };
    }

    case types.CLEAR_COMBO_ITEMS_DIALOG: {
      return {
        ...state,
        productList: [],
        productListLength: 0,
      };
    }

    case types.CLEAR_PRODUCT_LIST: {
      return {
        ...state,
        productList: [],
        productListLength: 0,
      };
    }

    case types.CLEAR_PO_LIST: {
      return {
        ...state,
        purchaseOrderList: [],
        purchaseOrderListLength: 0,
      };
    }

    case types.CLEAR_PRODUCT_TYPE_LIST: {
      return {
        ...state,
        productTypesList: [],
      };
    }

    case types.CLEAR_CATEGORY_TREE: {
      return {
        ...state,
        categoryTree: null,
      };
    }

    case types.CLEAR_PRODUCT_WAREHOUSES_LIST: {
      return {
        ...state,
        productsWarehouses: [],
      };
    }

    case types.CLEAR_BULK_TRANSFER_LIST: {
      return {
        ...state,
        bulkTransferList: [],
      };
    }

    case types.CLEAR_BRAND_LIST: {
      return {
        ...state,
        brandList: [],
      };
    }

    case types.CLEAR_INVENTORY_AUDIT: {
      return {
        ...state,
        inventoryAudit: { products: [] },
      };
    }

    case types.CLEAR_AUDIT_LIST: {
      return {
        ...state,
        inventoryAudits: [],
      };
    }

    case types.CLEAR_INVENTORY_ADJUST: {
      return {
        ...state,
        inventoryAdjust: [],
      };
    }

    case types.CLEAR_PRICE_MATRIX: {
      return {
        ...state,
        priceMatricesList: [],
      };
    }

    case types.CLEAR_EMPLOYEE_LIST: {
      return {
        ...state,
        employeeList: [],
      };
    }

    case types.CLEAR_MEMBER_ORDER_LIST: {
      return {
        ...state,
        patientOrders: [],
      };
    }

    case types.CLEAR_SCHEDULES_AND_EMPLOYEES: {
      return {
        ...state,
        schedules: [],
        employeeList: [],
        employeeSendList: [],
      };
    }

    case types.CLEAR_MEMBER_LIST: {
      return {
        ...state,
        patientList: [],
      };
    }

    //DISCOUNT

    case types.CLEAR_DISCOUNT_FORM: {
      return {
        ...state,
        customizedDiscount: null,
      };
    }

    case types.DISCOUNT_GET_ALL_SUCCESS: {
      return {
        ...state,
        customizedDiscounts: action.data,
      };
    }

    case types.DISCOUNT_GET_SUCCESS: {
      return {
        ...state,
        customizedDiscount: action.data,
      };
    }

    //REFUND
    case types.ADDED_REFUND_ORDER: {
      return {
        ...state,
        posOrder: action.data,
      };
    }

    // SHIFTS
    case types.SHIFTS_GOT: {
      return {
        ...state,
        shiftsList: action.data.list,
        shiftsListLength: action.data.total,
      };
    }

    case types.SHIFTS_GOT_FILTER: {
      return {
        ...state,
        shiftsListFilter: action.data.list,
        shiftsListFilterLength: action.data.total,
      };
    }

    case types.EMPLOYEE_SHIFT_GOT: {
      return {
        ...state,
        employeeShift: action.data,
      };
    }

    case types.CLEAR_EMPLOYEE_SHIFT: {
      return {
        ...state,
        employeeShift: null,
      };
    }

    // ORDER
    case types.ORDER_DETAIL_GOT: {
      return {
        ...state,
        orderDetail: action.data,
      };
    }

    case types.ORDERS_PATIENT_GOT: {
      return {
        ...state,
        patientOrders: action.data,
      };
    }

    // MIX AND MATCH
    case types.MIX_AND_MATCH_BY_ID_GOT: {
      return {
        ...state,
        mixAndMatch: { ...action.data },
      };
    }

    case types.MIX_AND_MATCHES_GOT: {
      return {
        ...state,
        mixAndMatchesList: [...action.data.list],
        mixAndMatchesListLength: action.data.total,
      };
    }

    case types.REWARD_POINTS_GOT: {
      return {
        ...state,
        patientRewardPoints: {
          list: action.data.list,
          total: action.data.total,
        },
      };
    }

    case types.REWARD_POINTS_ERROR: {
      return {
        ...state,
      };
    }

    //Ecommerce
    //TODO
    //Create Case for put productGroup on Store.
    case types.GOT_PRODUCT_GROUP_LIST: {
      return {
        ...state,
        productGroupList: {
          list: action.data.productGroups,
          total: action.data.totalCount,
        },
      };
    }

    case types.DELETE_STORE_RULES_SUCCESS:
    case types.GET_STORE_RULES_SUCCESS: {
      return {
        ...state,
        storeRulesList: action.data,
      };
    }

    case types.GET_STORE_RULE_BY_ID_SUCCESS: {
      return {
        ...state,
        storeRule: action.data,
      };
    }

    case types.GET_HOME_SETTINGS_ERROR: {
      return {
        ...state,
      };
    }

    case types.SET_USER_PIN_TO_STORE: {
      return {
        ...state,
        pin: {
          ...state.pin,
          authenticated: action.user.authenticated,
          employee: {
            id: action.user.employee.id,
            name: action.user.employee.name,
          },
        },
      };
    }

    case types.AUTH_PIN_PASSWORD_SUCCESS: {
      const pinUser = {
        authenticated: true,
        employee: {
          id: action.data.id,
          name: action.data.name,
        },
      };

      sessionStorage.setItem('pinUser', JSON.stringify(pinUser));
      sessionStorage.setItem('shouldRefreshPOS', 'true');

      return {
        ...state,
        pin: {
          ...state.pin,
          authenticated: true,
          employee: {
            id: action.data.id,
            name: action.data.name,
          },
          error: null,
        },
      };
    }

    case types.AUTH_PIN_PASSWORD_FAIL: {
      return {
        ...state,
        pin: {
          ...state.pin,
          error: action.error,
        },
      };
    }

    case types.VALIDATE_PIN_PASSWORD_SUCCESS: {
      return {
        ...state,
        pin: {
          ...state.pin,
          isValidPin: true,
        },
      };
    }

    case types.VALIDATE_PIN_PASSWORD_FAIL: {
      return {
        ...state,
        pin: {
          ...state.pin,
          isValidPin: false,
        },
      };
    }

    case types.RESET_VALIDATE_PIN_PASSWORD: {
      return {
        ...state,
        pin: {
          ...state.pin,
          isValidPin: null,
        },
      };
    }

    case types.AUTH_PIN_LOCK: {
      const pinUser = {
        authenticated: false,
        employee: {
          id: 0,
          name: '',
        },
      };
      sessionStorage.setItem('pinUser', JSON.stringify(pinUser));

      return {
        ...state,
        pin: {
          authenticated: false,
          employee: {
            id: 0,
            name: '',
          },
          error: null,
        },
      };
    }

    case types.LOGOUT_REQUEST: {
      return {
        ...state,
        pin: {
          authenticated: false,
          employee: {
            id: 0,
            name: '',
          },
          error: null,
        },
      };
    }

    //CHECKIN
    case types.GET_CHECK_IN_SUCCESS: {
      return {
        ...state,
        checkinList: action.data,
        addCheckIn: null,
        removeCheckIn: null,
      };
    }

    case types.CHECK_IN_SEARCH_SUCCESS:
      return {
        ...state,
        checkinSearchList: [...action.patients.list],
        checkinSearchLength: action.patients.total,
      };

    case types.CLEAN_ADD_CHECKIN_STORE: {
      return {
        ...state,
        addCheckIn: null,
        removeCheckIn: null,
      };
    }

    case types.ADD_CHECK_IN_SUCCESS: {
      return {
        ...state,
        checkinList: action.data,
        addCheckIn: true,
      };
    }

    case types.ADD_CHECK_IN_FAIL: {
      return {
        ...state,
        addCheckIn: false,
      };
    }

    case types.REMOVE_CHECK_IN_SUCCESS: {
      return {
        ...state,
        removeCheckIn: true,
      };
    }

    case types.REMOVE_CHECK_IN_ERROR: {
      return {
        ...state,
        removeCheckIn: false,
      };
    }

    case types.GET_CHECK_IN_BY_ID_SUCCESS: {
      return {
        ...state,
        checkInMember: { success: true, id: action.data.patient },
      };
    }

    //SET REWARD POINTS
    case types.SET_PATIENT_REWARD_SUCCESS: {
      return {
        ...state,
        setReward: true,
      };
    }

    case types.SET_PATIENT_VISIT_SUCCESS: {
      return {
        ...state,
        setVisit: true,
      };
    }

    case types.SET_PATIENT_REWARD_ERROR: {
      return {
        ...state,
        setReward: false,
      };
    }

    case types.SET_PATIENT_VISIT_ERROR: {
      return {
        ...state,
        setVisit: false,
      };
    }

    case types.GET_CHECK_IN_BY_ID_FAIL: {
      return {
        ...state,
        checkInMember: { success: false },
      };
    }

    case types.SET_PATIENT_REWARD_RESET: {
      return {
        ...state,
        setReward: null,
      };
    }

    case types.SET_PATIENT_VISIT_RESET: {
      return {
        ...state,
        setVisit: null,
      };
    }

    case types.GOT_SCHEDULES: {
      {
        return {
          ...state,
          schedules: { list: action.data.list, total: action.data.total },
        };
      }
    }

    case types.GOT_SCHEDULE_BY_EMPLOYEE: {
      {
        return {
          ...state,
          schedules: { list: action.data },
        };
      }
    }

    case types.CREATE_SCHEDULE_SUCCESS: {
      {
        return {
          ...state,
          scheduleCreatedId: action.data.id,
        };
      }
    }

    case types.REMOVE_SCHEDULE_SUCCESS: {
      {
        return {
          ...state,
          scheduleRemovedId: action.data.id,
        };
      }
    }

    case types.UPDATE_SCHEDULE_SUCCESS: {
      {
        return {
          ...state,
          scheduleUpdated: action.data.success,
          scheduleKeyUpdated: new Date().getTime(),
        };
      }
    }

    case types.GOT_CUSTOM_TIME_SLOTS: {
      return {
        ...state,
        scheduleCustomTimeSlots: action.data.data,
      };
    }

    case types.ADD_NEW_TIME_SLOT_SUCCESS: {
      return {
        ...state,
        scheduleCustomTimeSlots: action.data.data,
      };
    }

    case types.REMOVE_TIME_SLOT_SUCCESS: {
      return {
        ...state,
        scheduleCustomTimeSlots: action.data.data,
      };
    }

    case types.GET_ONLINE_ORDER_SUCCESS: {
      {
        return {
          ...state,
          onlineOrder: action.data,
          onlineOrderTotal: action.total,
        };
      }
    }

    case types.GET_ONLINE_ORDER_DETAILS_SUCCESS: {
      {
        return {
          ...state,
          onlineOrder: action.data,
        };
      }
    }

    case types.GET_ONLINE_ORDER_DETAILS_FAIL: {
      {
        return {
          ...state,
        };
      }
    }

    case types.GET_ONLINE_ORDER_DETAILS_BY_CODE_SUCCESS: {
      {
        return {
          ...state,
          onlineOrder: action.data,
        };
      }
    }

    case types.GET_ONLINE_ORDER_DETAILS_BY_CODE_FAIL: {
      {
        return {
          ...state,
          onlineOrder: null,
        };
      }
    }

    case types.GET_PICKUP_ORDER_DETAILS_BY_CODE_SUCCESS: {
      let pickUpProducts = [];
      action.data.products.map((product) => {
        let productVM = {
          orderProductId: product.id,
          productId: product.productId,
          packageReference: product.packageReference,
          quantity: product.quantity,
          unscannedQty: product.quantity,
          name: product.name,
          isCannabis: product.isCannabis,
        };
        pickUpProducts.push(productVM);
      });
      return {
        ...state,
        pickUpOrder: action.data,
        pickUpProducts: pickUpProducts,
        pickUpOrderSearchedTime: new Date().getTime(),
      };
    }

    case types.GET_PICKUP_ORDER_DETAILS_BY_CODE_FAIL: {
      return {
        ...state,
        pickUpOrder: null,
      };
    }

    case types.UPDATE_PICKUP_PRODUCTS: {
      return {
        ...state,
        pickUpProducts: state.pickUpProducts.map((item) => {
          return item.orderProductId == action.orderProductId
            ? {
                ...item,
                unscannedQty: action.unscannedQty - 1,
                packageReference: action.pkgReference,
              }
            : item;
        }),
      };
    }

    case types.UPDATE_STATUS_ONLINE_ORDER_SUCCESS: {
      {
        return {
          ...state,
          onlineOrderStatusUpdated: true,
          statusUpdatedTime: new Date().getTime(),
        };
      }
    }

    case types.UPDATE_STATUS_ONLINE_ORDER_FAIL: {
      {
        return {
          ...state,
          onlineOrderStatusUpdated: false,
          statusUpdatedTime: new Date().getTime(),
        };
      }
    }

    case types.CANCEL_ONLINE_ORDER_SUCCESS: {
      return {
        ...state,
        onlineOrders: action.data,
        cancelOnlineOrderTime: new Date().getTime(),
      };
    }

    case types.GET_ONLINE_ORDERS_QUEUE_SUCCESS: {
      {
        return {
          ...state,
          onlineOrders: action.data,
          openQueuedOrdersCount: action.openQueuedOrdersCount,
          openBuddiOrdersCount: action.openBuddiOrdersCount,
          openLeaflyOrdersCount: action.openLeaflyOrdersCount,
        };
      }
    }

    case types.GET_ONLINE_ORDERS_QUEUE_FAIL: {
      {
        return {
          ...state,
          onlineOrders: null,
        };
      }
    }

    case types.GET_PICKUP_ORDERS_QUEUE_SUCCESS: {
      {
        return {
          ...state,
          pickUpOrderIds: action.data,
        };
      }
    }

    case types.GET_PICKUP_ORDERS_QUEUE_FAIL: {
      {
        return {
          ...state,
          pickUpOrderIds: null,
        };
      }
    }

    case types.GET_STORETODOOR_PICKUP_TIME_SUCCESS: {
      {
        return {
          ...state,
          storetodoorPickupTimes: action.data.list,
        };
      }
    }

    case types.GET_STORETODOOR_LOCATION_INFO_SUCCESS: {
      {
        return {
          ...state,
          storetodoorLocationError: null,
          storetodoorLocationInfo: action.data,
        };
      }
    }

    case types.GET_STORETODOOR_LOCATION_INFO_FAIL: {
      {
        return {
          ...state,
          storetodoorLocationError: action.error,
          storetodoorLocationInfo: null,
        };
      }
    }

    case types.GET_STORETODOOR_PICKUP_TIME_FAIL: {
      {
        return {
          ...state,
          storetodoorPickupTimes: null,
        };
      }
    }

    case types.GET_PRESCRIPTIONS_BY_PATIENT_SUCCESS: {
      {
        return {
          ...state,
          prescriptions: action.data.list,
        };
      }
    }

    case types.GET_PRESCRIPTIONS_BY_PATIENT_FAIL: {
      {
        return {
          ...state,
          prescriptions: null,
        };
      }
    }

    case types.CREATE_PRESCRIPTION_SUCCESS: {
      {
        return {
          ...state,
          prescriptionId: action.data.id,
        };
      }
    }

    case types.CREATE_PRESCRIPTION_FAIL: {
      {
        return {
          ...state,
          prescriptionId: null,
        };
      }
    }

    case types.GENERATE_ORDER_BASED_ONLINE_ORDER_SUCCESS: {
      {
        return {
          ...state,
          generatedOrderId: action.data.generatedOrderId,
        };
      }
    }

    case types.GENERATE_ORDER_BASED_ONLINE_ORDER_FAIL: {
      {
        return {
          ...state,
          generatedOrderId: null,
          generateOrderErrorTime: new Date().getTime(),
          generateOrderError: action.error,
        };
      }
    }

    case types.FINISH_PICKUP_ORDER_SUCCESS: {
      return {
        ...state,
        finishedOrderId: action.data.id,
      };
    }

    case types.FINISH_PICKUP_ORDER_FAIL: {
      return {
        ...state,
        finishedOrderId: null,
      };
    }

    case types.GET_OPEN_ONLINE_ORDERS_COUNT_SUCCESS: {
      return {
        ...state,
        openQueuedOrdersCount: action.openQueuedOrdersCount,
        openBuddiOrdersCount: action.openBuddiOrdersCount,
        openLeaflyOrdersCount: action.openLeaflyOrdersCount,
      };
    }

    case types.SYNC_PRODUCTS_TO_LEAFLY_SUCCESS: {
      // console.log(action.data)
      // fetch(`https://api-sandbox.leafly.io/v1/menu_integration/45dd6ec56ad394da3ccf0a6ccb0460045bd614ab/menu/items`, {
      //     headers: {
      //       'Content-Type': 'application/json',
      //       'X-LEAFLY-PARTNER-API-KEY': 'jjOIKWq8fRva9CjRdZv8SbMSiR0LnYjnSbyO73ACXrljSZtM'
      //     },
      //     method: "POST",
      //     body: JSON.stringify(action.data)
      //   }).then((r) => {
      //     console.log(r);
      //   })
      return {
        ...state,
      };
    }

    case types.GET_MONERIS_RECEIPT_BY_ORDERID_SUCCESS: {
      return {
        ...state,
        monerisReceipts: action.data,
        monerisReceiptsTime: new Date().getTime(),
        monerisReceiptType: action.receiptType,
      };
    }

    case types.GIFT_CARD_BALANCE_PAGE_CHECK_SUCCESS: {
      return {
        ...state,
        POSGiftCardCheckResult: action.data,
        POSGiftCardCheckResultTime: new Date().getTime(),
      };
    }

    case types.GIFT_CARD_BALANCE_PAGE_CHECK_FAIL: {
      return {
        ...state,
        POSGiftCardCheckFailMessage: action.data,
        POSGiftCardCheckFailMessageTime: new Date().getTime(),
      };
    }

    case types.GIFT_CARD_CREATE_RELOAD_SUCCESS: {
      return {
        ...state,
        POSGenericGiftCardPurchaseSuccess: action.data,
        POSGenericGiftCardOrderSucessList:
          state.POSGenericGiftCardOrderSucessList
            ? [
                ...state.POSGenericGiftCardOrderSucessList,
                action.giftCardProductId,
              ]
            : [action.giftCardProductId],
        POSGenericGiftCardPurchaseSuccessTime: new Date().getTime(),
      };
    }

    case types.GIFT_CARD_CREATE_RELOAD_FAIL: {
      return {
        ...state,
        POSGenericGiftCardPurchaseFail: action.data,
        POSGenericGiftCardPurchaseFailTime: new Date().getTime(),
      };
    }

    case types.GIFT_CARD_PURCHASE_SUCCESS: {
      return {
        ...state,
        giftCardPurchaseResponse: action.data,
        giftCardPurchaseTime: new Date().getTime(),
      };
    }

    case types.CHARGE_GIFT_CARD_TO_ORDER_SUCCESS: {
      return {
        ...state,
        giftCardPurchaseSuccessResponse: action.data,
        giftCardPurchaseSuccessResponseTime: new Date().getTime(),
      };
    }

    case types.CHARGE_GIFT_CARD_TO_ORDER_FAIL: {
      return {
        ...state,
        giftCardPurchaseFailResponse: action.data,
        giftCardPurchaseFailResponseTime: new Date().getTime(),
      };
    }

    case types.GIFT_CARD_PURCHASE_FAIL: {
      return {
        ...state,
        giftCardPurchaseFailResponse: action.data,
        giftCardPurchaseFailResponseTime: new Date().getTime(),
      };
    }

    case types.GIFT_CARD_INITIALIZATION_SUCCESS: {
      return {
        ...state,
        giftCardInitializationTime: new Date().getTime(),
      };
    }

    case types.GIFT_CARD_DATA_INQUIRY_SUCCESS: {
      return {
        ...state,
        giftCardDatInquiryResponse: action.data,
      };
    }

    case types.GIFT_CARD_ACTIVATION_SUCCESS: {
      return {
        ...state,
        giftCardActivationResponse: action.data,
      };
    }

    case types.GIFT_CARD_ACTIVATION_FAIL: {
      return {
        ...state,
        giftCardActivationFailResponse: action.data,
      };
    }

    case types.GIFT_CARD_DEACTIVATION_SUCCESS: {
      return {
        ...state,
        giftCardDeactivationResponse: action.data,
      };
    }

    case types.GIFT_CARD_REFUND_SUCCESS: {
      return {
        ...state,
        giftCardRefundReponse: action.data,
      };
    }

    case types.UPLOAD_PRODUCT_SUCCESS: {
      return {
        ...state,
        uploadProductsTime: new Date().getTime(),
      };
    }

    case types.IMPORT_PRODUCTS_FROM_CATALOG_SUCCESS: {
      return {
        ...state,
        importedProducts: action.data,
        importedProductsTime: new Date().getTime(),
      };
    }

    case types.IMPORT_PRODUCTS_FROM_CATALOG_FAIL: {
      return {
        ...state,
        importedProductsError: action.error,
        importedProductsErrorTime: new Date().getTime(),
      };
    }
    case types.POS_ORDER_IMPORT_TEMPLATE_SUCCESS: {
      return {
        ...state,
        importedOrdersResult: action.resultSKUs,
        posOrder: { ...action.data },
        cashFlow: action.currentCashFlow
          ? action.currentCashFlow
          : state.cashFlow,
        importedOrdersTime: new Date().getTime(),
      };
    }

    case types.POS_ORDER_IMPORT_TEMPLATE_FAIL: {
      return {
        ...state,
        importedOrdersResult: action.resultSKUs,
        importedOrdersError: action.error,
        importedOrdersErrorTime: new Date().getTime(),
        posOrder: { ...action.data },
      };
    }

    case types.POS_ORDER_IMPORT_TEMPLATE_CLEAR: {
      return {
        ...state,
        importedOrdersResult: null,
      };
    }

    case types.SYNC_FROM_CATALOG_SUCCESS: {
      return {
        ...state,
        syncProductsInfoTime: new Date().getTime(),
      };
    }

    case types.SYNC_FROM_CATALOG_FAILED: {
      return {
        ...state,
        syncProductsInfoError: action.error,
        syncProductsInfoErrorTime: new Date().getTime(),
      };
    }

    case types.GET_CLOSING_INVENTORY_PRODUCT_SUCCESS: {
      return {
        ...state,
        closingInventoryStatus: action.data,
        closingInventoryTimeShot: new Date().getTime(),
      };
    }

    case types.GET_PRODUCT_INVENTORY_BY_BRANCH_SUCCESS: {
      if (action.mode == LOOKUP.ProductInventoryByBranchType.branchTo) {
        return {
          ...state,
          productInventoryByBranchTo: action.data,
        };
      } else {
        return {
          ...state,
          productInventoryByBranchFrom: action.data,
        };
      }
    }

    case types.CLEAN_PRODUCT_INVENTORY_BY_BRANCH: {
      return {
        ...state,
        productInventoryByBranchTo: null,
        productInventoryByBranchFrom: null,
      };
    }

    case types.PAYSTONE_GIFTCARD_OPERATION_SUCCESS: {
      return {
        ...state,
        paystoneGiftCardOperation: action.data,
      };
    }

    case types.BIRCHMOUNT_GIFTCARD_OPERATION_SUCCESS: {
      return {
        ...state,
        birchmountGiftCardOperation: action.data,
      };
    }

    case types.PAYSTONE_GIFTCARD_PURCHASE_SUCCESS: {
      return {
        ...state,
        paystoneGiftCardPurchaseData: action.data,
        paystoneGiftCardPurchaseTime: new Date().getTime(),
      };
    }

    case types.PAYSTONE_GIFTCARD_REFUND_SUCCESS: {
      return {
        ...state,
        paystoneGiftCardRefundData: action.data,
        paystoneGiftCardRefundTime: new Date().getTime(),
      };
    }

    case types.BIRCHMOUNT_GIFT_CARD_PURCHASE_SUCCESS: {
      return {
        ...state,
        birchmountGiftCardPurchaseData: action.data,
        birchmountGiftCardPurchaseTime: new Date().getTime(),
      };
    }

    case types.BIRCHMOUNT_GIFT_CARD_REFUND_SUCCESS: {
      return {
        ...state,
        birchmountGiftCardRefundData: action.data,
        birchmountGiftCardRefundTime: new Date().getTime(),
      };
    }
    case types.PURCHASE_ORDER_IMPORT_SUCCESS: {
      return {
        ...state,
        purchaseOrderImportSuccessTime: new Date().getTime(),
        createdSKUs: action.createdSKUs,
      };
    }
    case types.PURCHASE_ORDER_CANNABIS_TEMPLATE_SUCCESS: {
      return {
        ...state,
        purchaseOrderImportSuccessTime: new Date().getTime(),
      };
    }
    case types.PURCHASE_ORDER_IMPORT_FAIL: {
      return {
        ...state,
        purchaseOrderImportFailError: action.error,
        purchaseOrderImportFailTime: new Date().getTime(),
      };
    }

    case types.SEND_MESSAGE_SUCCESS: {
      return {
        ...state,
        messageStatus: true,
      };
    }

    case types.RESET_MESSAGE_SUCCESS: {
      return {
        ...state,
        messageStatus: false,
      };
    }

    case types.UPLOAD_IMAGE_SUCCESS: {
      return {
        ...state,
        imageURL: action.data.url,
      };
    }

    case types.GET_SPRINGBIG_OFFERS_SUCCESS: {
      return {
        ...state,
        springBigOffers: action.data,
      };
    }

    case types.GET_SPRINGBIG_REWARDS_SUCCESS: {
      return {
        ...state,
        springBigRewards: action.data,
      };
    }

    case types.GET_SPRINGBIG_MEMBERPOINTS_SUCCESS: {
      return {
        ...state,
        springBigMemberPoints: action.data,
      };
    }

    case types.ALPINEIQ_VERIFY_WALLET_SUCCESS: {
      return {
        ...state,
        alpineIQverify: action.data,
      };
    }

    case types.ALPINEIQ_VIEW_WALLET_SUCCESS: {
      return {
        ...state,
        alpineIQverify: null,
        alpineIQwallet: action.data.discountTemplates,
        alpineIQPoints: action.data.loyaltyPoints,
      };
    }

    case types.CLEAR_ALPINEIQ: {
      return {
        ...state,
        alpineIQverify: null,
        alpineIQwallet: null,
        alpineIQPoints: null,
      };
    }

    case types.GET_PRODUCT_MOODS_SUCCESS: {
      return {
        ...state,
        productMoods: action.data,
      };
    }

    case types.GET_MOODS_SUCCESS: {
      return {
        ...state,
        moods: action.data,
      };
    }

    case types.ASSIGN_MOOD_SUCCESS: {
      return {
        ...state,
        moodsSuccess: true,
      };
    }

    case types.RESET_ASSIGN_MOODS: {
      return {
        ...state,
        moodsSuccess: false,
      };
    }

    case types.ADD_MOOD_SUCCESS: {
      return {
        ...state,
        addMoodSuccess: true,
      };
    }

    case types.RESET_ADD_MOOD: {
      return {
        ...state,
        addMoodSuccess: false,
      };
    }

    case types.GET_PRODUCT_TERPENES_SUCCESS: {
      return {
        ...state,
        productTerpenes: action.data,
        getTerpenesSuccess: true,
      };
    }

    case types.RESET_GET_TERPENES: {
      return {
        ...state,
        getTerpenesSuccess: false,
      };
    }

    case types.GET_TERPENES_SUCCESS: {
      return {
        ...state,
        terpenes: action.data,
      };
    }

    case types.ASSIGN_TERPENE_SUCCESS: {
      return {
        ...state,
        terpenesSuccess: true,
      };
    }

    case types.RESET_ASSIGN_TERPENES: {
      return {
        ...state,
        terpenesSuccess: false,
      };
    }

    case types.ADD_TERPENE_SUCCESS: {
      return {
        ...state,
        addTerpeneSuccess: true,
      };
    }

    case types.RESET_ADD_TERPENE: {
      return {
        ...state,
        addTerpeneSuccess: false,
      };
    }

    case types.GET_PRODUCT_MINORCANABINOIDS_SUCCESS: {
      return {
        ...state,
        productMinorCanabinoids: action.data,
        getMinorCanabinoidsSuccess: true,
      };
    }

    case types.RESET_GET_MINORCANABINOIDS: {
      return {
        ...state,
        getMinorCanabinoidsSuccess: false,
      };
    }

    case types.GET_MINORCANABINOIDS_SUCCESS: {
      return {
        ...state,
        minorCanabinoids: action.data,
      };
    }

    case types.ASSIGN_MINORCANABINOID_SUCCESS: {
      return {
        ...state,
        minorCanabinoidsSuccess: true,
      };
    }

    case types.RESET_ASSIGN_MINORCANABINOIDS: {
      return {
        ...state,
        minorCanabinoidsSuccess: false,
      };
    }

    case types.ADD_MINORCANABINOID_SUCCESS: {
      return {
        ...state,
        addMinorCanabinoidSuccess: true,
      };
    }

    case types.RESET_ADD_MINORCANABINOID: {
      return {
        ...state,
        addMinorCanabinoidSuccess: false,
      };
    }

    case types.GET_ACCESSORY_VENDORS_SUCCESS: {
      return {
        ...state,
        accessoryVendors: action.data,
      };
    }

    case types.SAVE_CLOCKIN_CLOCKOUT_ERROR: {
      return {
        ...state,
        employeeBranchesInfo: action.branchInfo,
      };
    }

    case types.GOT_PRODUCT_INVENTORY_BY_BRANCH_DATE: {
      return {
        ...state,
        productInventoryByBranchAndDate: action.data,
      };
    }

    case types.GOT_MULTI_BRANCH_INVENTORY: {
      return {
        ...state,
        multiStoreInventoryData: action.data,
      };
    }

    case types.SET_RESTOCK_QTY_SUCCESS: {
      const formattedDate = moment().format('MM-DD-YYYY HH:mm:ss');
      return {
        ...state,
        reStockCapSet: formattedDate,
      };
    }

    case types.GOT_SINGLE_PRODUCT_INVENTORY: {
      return {
        ...state,
        singleStoreInventoryData: action.data,
      };
    }

    case types.GOT_SINGLE_PRODUCT_INVENTORY_FAIL: {
      return {
        ...state,
        singleStoreInventoryData: [
          {
            branchId: 0,
            damageQty: 0,
            quantity: 0,
            reStockCap: 0,
            storageQty: 0,
            storeQty: 0,
          },
        ],
      };
    }

    case types.GET_REPORT_AUTOMATION_INFO_SUCCESS: {
      return {
        ...state,
        reportAutomationInfo: action.data,
      };
    }

    case types.GET_WEB_UI_SETTINGS_INTEGRATION_SUCCESS: {
      return {
        ...state,
        webMenuUISettings: action.data,
      };
    }

    case types.APPLICATION_SETTING_INTEGRATION_GOT: {
      return {
        ...state,
        additionalSettings: {
          machoolEnabled: action.data.machoolEnabled,
          headSetEnabled: action.data.headSetEnabled,
          budvueEnabled: action.data.budvueEnabled,
          budSenseEnabled: action.data.budSenseEnabled,
          soLinkEnabled: action.data.soLinkEnabled,
          cannaCollectiveEnabled: action.data.cannaCollectiveEnabled,
          irccEnabled: action.data.irccEnabled,
          quickBooksEnabled: action.data.quickBooksEnabled,
        },
      };
    }
    case types.GET_STORE_LOCK_DATE_AND_TIME_SUCCESS: {
      return {
        ...state,
        storeLockDateAndTimeLists: action.data,
      };
    }

    case types.CREATE_STORE_LOCK_DATE_AND_TIME_SUCCESS: {
      return {
        ...state,
        createStoreLockDateNTimeSuccess: new Date().getTime(),
      };
    }

    case types.CREATE_STORE_TO_DOOR_DELIVERY_TIME_FAILED: {
      return {
        ...state,
        createStoreToDoorFailed: new Date().getTime(),
        createStoreToDoorMessageFailed: action.error,
      };
    }

    case types.CREATE_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS: {
      const { weekday, timeSlots: newTimeSlots } = action.data;
      const day = Object.keys(state.deliveryData).find(
        (day) => state.deliveryData[day].weekday === weekday
      );

      const updatedTimeSlots = state.deliveryData[day].timeSlots.some(
        (slot) => slot.id === 0
      )
        ? state.deliveryData[day].timeSlots.map((slot) =>
            slot.id === 0
              ? {
                  ...slot,
                  ...newTimeSlots[0], // Replace the slot with id === 0
                  id: newTimeSlots[0].id,
                }
              : slot
          )
        : [
            ...state.deliveryData[day].timeSlots,
            newTimeSlots[0], // Add newTimeSlots[0] if no slot with id === 0
          ];

      return {
        ...state,
        deliveryData: {
          ...state.deliveryData,
          [day]: {
            ...state.deliveryData[day],
            timeSlots: updatedTimeSlots,
          },
        },
        createdState: new Date().getTime(), // Ensure React detects a change
      };
    }

    case types.DELETE_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS: {
      const id = action.data;

      return {
        ...state,
        deliveryData: Object.keys(state.deliveryData).reduce(
          (updatedDeliveryData, day) => {
            const dayData = state.deliveryData[day];

            const updatedTimeSlots = dayData.timeSlots.filter(
              (slot) => slot.id !== id
            );
            updatedDeliveryData[day] = {
              ...dayData,
              timeSlots: updatedTimeSlots,
            };

            return updatedDeliveryData;
          },
          {}
        ),
        deletedState: new Date().getTime(), // Ensure React detects a change
      };
    }

    case types.DELETE_STORE_TO_DOOR_DELIVERY_TIME_FAILED: {
      return {
        ...state,
        deletedStoreLockDateNTimeFailed: new Date().getTime(),
      };
    }

    case types.UPDATE_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS: {
      const { weekday, timeSlots: newTimeSlots } = action.data;
      const day = Object.keys(state.deliveryData).find(
        (day) => state.deliveryData[day].weekday === weekday
      );

      // Ensure the existing slot with the same ID is replaced
      const updatedTimeSlots = state.deliveryData[day].timeSlots.map((slot) =>
        slot.id === newTimeSlots[0].id ? { ...slot, ...newTimeSlots[0] } : slot
      );

      // If no existing slot was updated, add the new one
      const isUpdated = state.deliveryData[day].timeSlots.some(
        (slot) => slot.id === newTimeSlots[0].id
      );

      return {
        ...state,
        deliveryData: {
          ...state.deliveryData,
          [day]: {
            ...state.deliveryData[day],
            timeSlots: isUpdated
              ? updatedTimeSlots
              : [...updatedTimeSlots, newTimeSlots[0]],
          },
        },
        updatedStoreLockDateNTimeSuccess: action.success,
      };
    }

    case types.RESET_UPDATE_STORE_TO_DOOR_DELIVERY_TIME: {
      return {
        ...state,
        updatedStoreLockDateNTimeSuccess: false,
      };
    }

    case types.UPDATE_STORE_TO_DOOR_DELIVERY_TIME_FAILED: {
      return {
        ...state,
        updatedStoreDeliveryDateTimeFailed: new Date().getTime(),
        updatedStoreDeliveryDateTimeMessageFailed: action.error,
      };
    }

    case types.GET_ALL_STORE_TO_DOOR_DELIVERY_TIME_SUCCESS: {
      return {
        ...state,
        deliveryData: action.data,
      };
    }

    case types.CREATE_STORE_LOCK_DATE_AND_TIME_FAILED: {
      return {
        ...state,
        createStoreLockDateNTimeFailed: new Date().getTime(),
      };
    }

    case types.DELETE_STORE_LOCK_DATE_AND_TIME_SUCCESS: {
      return {
        ...state,
        deleteStoreLockDateNTimeSuccess: new Date().getTime(),
      };
    }

    case types.DELETE_STORE_LOCK_DATE_AND_TIME_FAILED: {
      return {
        ...state,
        deleteStoreLockDateNTimeFailed: action.error,
      };
    }

    case types.UPDATE_STORE_LOCK_DATE_AND_TIME_SUCCESS: {
      return {
        ...state,
        updateStoreLockDateNTimeSuccess: new Date().getTime(),
      };
    }

    case types.UPDATE_STORE_LOCK_DATE_AND_TIME_FAILED: {
      return {
        ...state,
        updateStoreLockDateNTimeFailed: action.error,
      };
    }
    case types.BULK_PRICE_UPDATE_BY_EXCEL: {
      return {
        ...state,
        uploadexcel: action.data,
      };
    }

    case types.UPLOAD_EXCEL_SUCCESS: {
      return {
        ...state,
        updatePriceSchedularUpdateTimeSuccess: new Date().getTime(),
      };
    }

    case types.GET_BULK_PRICE_SCHEDULAR_SUCCESS: {
      return {
        ...state,
        bulkPriceSchedularList: action.data.list,
        bulkPriceSchedularLength: action.data.total,
      };
    }

    case types.DELETE_BULK_PRICE_LIST_SUCCESS: {
      return {
        ...state,
        updatePriceSchedularUpdateTimeSuccess: new Date().getTime(),
      };
    }

    case types.UPDATE_BULK_PRICE_LIST: {
      return {
        ...state,
        updatePriceList: action.data,
      };
    }
    case types.VALIDATE_BULK_PRICE_EXCEL: {
      return {
        ...state,
      };
    }

    case types.VALIDATE_BULK_PRICE_EXCEL_SUCCESS: {
      return {
        ...state,
        validateExcelTimeSuccess: new Date().getTime(),
        bulkPriceUpdateNotFoundSKUList: action.data,
      };
    }

    case types.UPDATE_BULK_PRICE_LIST_SUCCESS: {
      return {
        ...state,
        updateBulkPriceListSuccessTime: new Date().getTime(),
        updateBulkPriceListData: action.data,
      };
    }

    case types.UNRECEIVE_ALL_SUCCESS: {
      return {
        ...state,
        unreceiveAllSuccess: new Date().getTime(),
      };
    }

    case types.DELETE_PO_SUCCESS: {
      return {
        ...state,
        deletePOSuccess: new Date().getTime(),
      };
    }

    case types.UPDATE_PRICE_MATCH_PRODUCT: {
      const { modal = [] } = action || {};
      const newPriceMatchRows =
        state.priceMatchRows && state.priceMatchRows.length > 0
          ? [...state.priceMatchRows, ...modal]
          : modal;
      return {
        ...state,
        priceMatchRows: newPriceMatchRows,
      };
    }

    case types.CLEAR_PRICE_MATCH_ROWS: {
      return {
        ...state,
        priceMatchRows: [], // Clear the priceMatchRows
      };
    }

    case types.REMOVE_PRICE_MATCH_PRODUCT: {
      const { modal = '' } = action || {};
      return {
        ...state,
        priceMatchRows: state.priceMatchRows.filter((row) => row.id !== modal), // Remove row with the matching id
      };
    }

    case types.POST_NEW_PRODUCT_IMAGE: {
      return {
        ...state,
        imagUploadingPending: true,
        imagUploadingSuccess: false,
        imagUploadingError: false,
      };
    }
    case types.POST_NEW_PRODUCT_IMAGE_SUCCESS: {
      return {
        ...state,
        imagUploadingPending: false,
        imagUploadingSuccess: true,
      };
    }

    case types.POST_NEW_PRODUCT_IMAGE_FAILED: {
      return {
        ...state,
        imagUploadingPending: false,
        imagUploadingError: true,
      };
    }

    case types.DELETE_PRODUCT_IMAGE_REQUEST: {
      return {
        ...state,
        deleteImagePending: true,
        deleteImageSuccess: false,
        deleteImageError: false,
      };
    }
    case types.DELETE_PRODUCT_IMAGE_SUCCESS: {
      return {
        ...state,
        deleteImagePending: false,
        deleteImageSuccess: true,
      };
    }

    case types.DELETE_PRODUCT_IMAGE_FAILED: {
      return {
        ...state,
        deleteImagePending: false,
        deleteImageError: true,
      };
    }

    case types.GET_PRODUCT_INFO_REQUEST: {
      return {
        ...state,
        getProductInfoPending: true,
        productInfoResult: null,
        getProductInfoError: false,
      };
    }
    case types.GET_PRODUCT_INFO_SUCCESS: {
      return {
        ...state,
        getProductInfoPending: false,
        productInfoResult: action.data,
      };
    }

    case types.GET_PRODUCT_INFO_FAILED: {
      return {
        ...state,
        getProductInfoPending: false,
        getProductInfoError: true,
      };
    }

    case types.GET_STORE_SEO_SETTINGS_REQUEST: {
      return {
        ...state,
        getSEOSettingsPending: true,
        getSEOSettingsError: false,
      };
    }
    case types.GET_STORE_SEO_SETTINGS_SUCCESS: {
      return {
        ...state,
        getSEOSettingsPending: false,
        seoSettings: action.data,
      };
    }
    case types.GET_STORE_SEO_SETTINGS_FAILED: {
      return {
        ...state,
        getSEOSettingsPending: false,
        getSEOSettingsError: action.data,
      };
    }

    case types.UPDATE_STORE_SEO_SETTINGS_REQUEST: {
      return {
        ...state,
        updateSEOSettingsPending: true,
        updateSEOSettingsSuccess: false,
        updateSEOSettingsError: false,
      };
    }
    case types.UPDATE_STORE_SEO_SETTINGS_SUCCESS: {
      return {
        ...state,
        updateSEOSettingsPending: false,
        updateSEOSettingsSuccess: true,
      };
    }
    case types.UPDATE_STORE_SEO_SETTINGS_FAILED: {
      return {
        ...state,
        updateSEOSettingsPending: false,
        updateSEOSettingsError: action.data,
      };
    }

    case types.GET_STORE_SEO_SETTINGS_REQUEST: {
      return {
        ...state,
        getSEOSettingsPending: true,
        getSEOSettingsError: false,
      };
    }
    case types.GET_STORE_SEO_SETTINGS_SUCCESS: {
      return {
        ...state,
        getSEOSettingsPending: false,
        seoSettings: action.data,
      };
    }
    case types.GET_STORE_SEO_SETTINGS_FAILED: {
      return {
        ...state,
        getSEOSettingsPending: false,
        getSEOSettingsError: action.data,
      };
    }

    case types.UPDATE_STORE_SEO_SETTINGS_REQUEST: {
      return {
        ...state,
        updateSEOSettingsPending: true,
        updateSEOSettingsSuccess: false,
        updateSEOSettingsError: false,
      };
    }
    case types.UPDATE_STORE_SEO_SETTINGS_SUCCESS: {
      return {
        ...state,
        updateSEOSettingsPending: false,
        updateSEOSettingsSuccess: true,
      };
    }
    case types.UPDATE_STORE_SEO_SETTINGS_FAILED: {
      return {
        ...state,
        updateSEOSettingsPending: false,
        updateSEOSettingsError: action.data,
      };
    }
    ///- Get product group images
    case types.GET_PRODUCT_GROUP_IMAGE_REQUEST: {
      return {
        ...state,
        getProductGroupImagesPending: true,
        getProductGroupImagesSuccess: false,
        getProductGroupImagesError: false,
      };
    }
    case types.GET_PRODUCT_GROUP_IMAGE_SUCCESS: {
      return {
        ...state,
        getProductGroupImagesPending: false,
        getProductGroupImagesSuccess: true,
        productGroupImages: action.data,
      };
    }
    case types.GET_PRODUCT_GROUP_IMAGE_FAILED: {
      return {
        ...state,
        getProductGroupImagesPending: false,
        getProductGroupImagesError: action.data,
      };
    }
    ///- Add product group image
    case types.ADD_PRODUCT_GROUP_IMAGE_REQUEST: {
      return {
        ...state,
        addProductGroupImagesPending: true,
        addProductGroupImagesSuccess: false,
        addProductGroupImagesError: false,
      };
    }
    case types.ADD_PRODUCT_GROUP_IMAGE_SUCCESS: {
      return {
        ...state,
        addProductGroupImagesPending: false,
        addProductGroupImagesSuccess: true,
      };
    }
    case types.ADD_PRODUCT_GROUP_IMAGE_FAILED: {
      return {
        ...state,
        addProductGroupImagesPending: false,
        addProductGroupImagesError: action.data,
      };
    }
    ///- Delete product group image
    case types.DELETE_PRODUCT_GROUP_IMAGE_REQUEST: {
      return {
        ...state,
        deleteProductGroupImagesPending: true,
        deleteProductGroupImagesSuccess: false,
        deleteProductGroupImagesError: false,
      };
    }
    case types.DELETE_PRODUCT_GROUP_IMAGE_SUCCESS: {
      return {
        ...state,
        deleteProductGroupImagesPending: false,
        deleteProductGroupImagesSuccess: true,
      };
    }
    case types.DELETE_PRODUCT_GROUP_IMAGE_FAILED: {
      return {
        ...state,
        deleteProductGroupImagesPending: false,
        deleteProductGroupImagesError: action.data,
      };
    }

    case types.ADYEN_PAYMENT_SUCCESS: {
      return {
        ...state,
        adyenPaymentResponse: action.data,
        adyenPaymentSuccessTime: new Date().getTime(),
      };
    }

    case types.ADYEN_REFUND_SUCCESS: {
      return {
        ...state,
        adyenRefundResponse: action.data,
        adyenRefundSuccessTime: new Date().getTime(),
      };
    }

    case types.GET_ALL_BANNER_SUCCESS: {
      return {
        ...state,
        bannerDataSuccess: action.data,
      };
    }
    case types.GET_ALL_BANNER_FAILED: {
      return {
        ...state,
        bannerDataFailed: action.data,
      };
    }
    case types.ADD_BANNER_SUCCESS: {
      return {
        ...state,
        bannerSaveSuccess: action.data,
        bannersSaveSuccess: true,
      };
    }
    case types.ADD_BANNER_FAILED: {
      return {
        ...state,
        bannerSaveFailed: action.data,
        bannersSaveSuccess: false,
      };
    }
    case types.UPDATE_BANNER_SUCCESS: {
      return {
        ...state,
        bannerUpdateSuccess: action.data,
        bannersSaveSuccess: true,
      };
    }
    case types.UPDATE_BANNER_FAILED: {
      return {
        ...state,
        bannerUpdateFailed: action.data,
        bannersSaveSuccess: false,
      };
    }
    case types.GET_BANNER_BY_ID_SUCCESS: {
      return {
        ...state,
        bannerData: action.data,
        bannerGetSuccess: true,
      };
    }
    case types.GET_BANNER_BY_ID_FAILED: {
      return {
        ...state,
        banmarDataFailed: action.data,
        bannerGetSuccess: false,
      };
    }
    case types.REMOVE_BANNER_IMAGE_SUCCESS: {
      return {
        ...state,
        bannerImageRemove: action.data,
      };
    }
    case types.REMOVE_BANNER_IMAGE_FAILED: {
      return {
        ...state,
        bannerImageRemoveFailed: action.data,
      };
    }
    case types.RESET_BANNER_SAVE_SUCCESS: {
      return {
        ...state,
        bannersSaveSuccess: null,
      };
    }
    default:
      return state;
  }
}
